import { cn } from "@design-system/Utilities";
import {
    type FC,
    type InputHTMLAttributes,
    type Ref,
    useImperativeHandle,
    useRef,
} from "react";

import {
    FieldWrapper,
    type SharedProps,
} from "@design-system/Inputs/Textfield/FieldWrapper";
import { FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
type NumberFieldSpecificProps = {
    align?: "left" | "right";
    hideControls?: boolean;
    unit?: string;
};
export interface NumberfieldProps
    extends InputHTMLAttributes<HTMLInputElement>,
        SharedProps,
        NumberFieldSpecificProps {}

export const Numberfield: FC<
    NumberfieldProps & { ref?: Ref<HTMLInputElement> }
> = ({
    align = "left",
    className,
    hideControls = false,
    hint,
    error,
    placeholder,
    ref,
    required,
    success,
    unit,
    ...props
}) => {
    const inputRef = useRef<HTMLInputElement>(null);
    useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);

    const placeholderUp = props.value != null || props.defaultValue != null;

    return (
        <FieldWrapper
            inputRef={inputRef}
            placeholder={placeholder}
            hint={hint}
            success={success}
            error={error}
            disabled={props.disabled}
            htmlFor={props.id}
            placeholderUp={placeholderUp}
            required={required}
        >
            <FlexRow alignItems="center">
                <input
                    className={cn(
                        "bg-transparent w-full p-0",
                        "font-default text-base font-regular leading-[20px]",
                        "border-0 focus:ring-0 placeholder:text-neutral-500 resize-none disabled:text-neutral-500",
                        align === "right" && "text-right",
                        hideControls && "hide-controls",
                        className,
                    )}
                    ref={inputRef}
                    required={required}
                    type="number"
                    {...props}
                />
                {unit ? (
                    <Text as="span" color="tertiary" ml="1">
                        {unit}
                    </Text>
                ) : null}
            </FlexRow>
        </FieldWrapper>
    );
};
